// frontend/src/views/weight-estimations/WeightEstimationsView.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import PanelTemplate from '../../templates/PanelTemplate';
import WeightEstimationTemplate from '../../templates/weight-estimations/WeightEstimationTemplate';
import GetAllWeightEstimations from '../../containers/weight-estimations/GetAllWeightEstimations';

function WeightEstimationsView() {
    const navigate = useNavigate();
    const estimationsProps = GetAllWeightEstimations();

    const handleViewClick = (estimationId) => {
        navigate(`/weight-estimations/${estimationId}`);
    };

    const handleEstimateClick = () => {
        navigate('/weight-estimations/estimate');
    };

    return (
        <PanelTemplate 
            content={
                <WeightEstimationTemplate 
                    {...estimationsProps} 
                    onViewClick={handleViewClick}
                    onDeleteClick={estimationsProps.onDeleteClick}
                    onEstimateClick={handleEstimateClick}
                    showDeleteDialog={estimationsProps.showDeleteDialog}
                    deleteItem={estimationsProps.deleteItem}
                    onCloseDeleteDialog={estimationsProps.onCloseDeleteDialog}
                    onConfirmDelete={estimationsProps.onConfirmDelete}
                    refreshData={estimationsProps.refreshData}
                />
            } 
        />
    );
}

export default WeightEstimationsView;

